"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledIcon = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _icon = _interopRequireDefault(require("../../../icon"));

var _defaultOption = _interopRequireDefault(require("./default-option"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledIcon = (
/*#__PURE__*/
0, _styledBase.default)(_icon.default, {
  target: "elvcw970"
})("margin-right:calc(", (0, _styledSystem.themeGet)('spacing.2'), "px + ", (0, _styledSystem.themeGet)('spacing.9'), "px);" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9mb3JtLWlucHV0cy90eXBlLWFoZWFkL2N1c3RvbS1vcHRpb25zL3dpdGgtaWNvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPc0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2Zvcm0taW5wdXRzL3R5cGUtYWhlYWQvY3VzdG9tLW9wdGlvbnMvd2l0aC1pY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHRoZW1lR2V0IH0gZnJvbSAnc3R5bGVkLXN5c3RlbSc7XG5cbmltcG9ydCBJY29uIGZyb20gJy4uLy4uLy4uL2ljb24nO1xuaW1wb3J0IERlZmF1bHRPcHRpb24gZnJvbSAnLi9kZWZhdWx0LW9wdGlvbic7XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJY29uID0gc3R5bGVkKEljb24pYFxuICBtYXJnaW4tcmlnaHQ6IGNhbGMoJHt0aGVtZUdldCgnc3BhY2luZy4yJyl9cHggKyAke3RoZW1lR2V0KCdzcGFjaW5nLjknKX1weCk7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCAoeyBpY29uLCBxYVNlbGVjdG9yLCBsYWJlbCwgd2lkdGgsIGlzTGluaywgZnVuYyB9KSA9PiAoXG4gIDxSZWFjdC5GcmFnbWVudD5cbiAgICA8U3R5bGVkSWNvbiBpY29uPXtpY29ufSB3aWR0aD17YCR7d2lkdGh9cHhgfSAvPlxuICAgIDxEZWZhdWx0T3B0aW9uIHFhU2VsZWN0b3I9e3FhU2VsZWN0b3J9IGxhYmVsPXtsYWJlbH0gaXNMaW5rPXtpc0xpbmt9IGZ1bmM9e2Z1bmN9IC8+XG4gIDwvUmVhY3QuRnJhZ21lbnQ+XG4pO1xuIl19 */"));
exports.StyledIcon = StyledIcon;

var _default = function _default(_ref) {
  var icon = _ref.icon,
      qaSelector = _ref.qaSelector,
      label = _ref.label,
      width = _ref.width,
      isLink = _ref.isLink,
      func = _ref.func;
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(StyledIcon, {
    icon: icon,
    width: "".concat(width, "px")
  }), (0, _core.jsx)(_defaultOption.default, {
    qaSelector: qaSelector,
    label: label,
    isLink: isLink,
    func: func
  }));
};

exports.default = _default;